import styled from 'styled-components';

const HeroImageWrapper = styled.div`
  overflow: hidden;
  height: 100%;
`;

export default HeroImageWrapper;
